/**
 * Il corpo di ogni vista, sotto la `Testata`: tutta la larghezza del guscio,
 * con un margine che cresce con lo schermo. Nessuna vista si mette un limite
 * di larghezza sul contenitore: lo mettono solo i blocchi che lo chiedono,
 * come i campi di un modulo (`docs/navigazione-e-viste.md`, §1.9).
 */

import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

/** Margine orizzontale del corpo, lo stesso che allinea il titolo in `Testata`. */
export const MARGINE_X = 'px-4 md:px-6 xl:px-8';

export function Corpo({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('py-4 md:py-6', MARGINE_X, className)} {...props} />;
}
